import { Route, Routes } from 'react-router';

import Pagenotfound from '../components/views/PageNotFound';
import LinkedInAuth from './components/LinkedInAuth';
import BeginnerGuide from './components/Linkedinlandingpages';
import DownloadInstaller from './components/DownloadInstaller';
import PrivateRoute from './SecurityConfig/PrivateRoute';
import AuthContextProvider from './SecurityConfig/AuthContextProvider';

function GuntechlinkedinPost() {
  return (
    <div className="">
      <AuthContextProvider>
        <Routes>
          {/* <Route path = '/' element= {<SendOtp/>}/> */}
          <Route path="/linkedinpost">
            <Route path="" element={<BeginnerGuide />} />
            <Route path="*" element={<Pagenotfound />} />
            <Route path="signin" element={<LinkedInAuth />} />
            <Route
              path="download"
              element={
                <PrivateRoute>
                  <DownloadInstaller />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </AuthContextProvider>
    </div>
  );
}

export default GuntechlinkedinPost;
